import i18n from 'i18next';

import getAgendaItemSchema from './getAgendaItemSchema';

export default ({ adminSettings }) => {
  const { data: { locales = [] } = {} } = adminSettings;

  return {
    name: {
      type: 'Text',
      label: i18n.t('video-title'),
      validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
      maxLength: 100,
    },
    locale: {
      type: 'Select',
      label: i18n.t('locale'),
      selectProps: {
        placeholder: i18n.t('locales-placeholder'),
        noOptionsMessage: () => i18n.t('locales-empty'),
      },
      options: locales.map(({ key, name }, i) => ({
        id: i,
        label: name,
        value: key,
      })),
      validators: [{ type: 'isRequired' }],
    },
    agenda_item: getAgendaItemSchema({ adminSettings, isEditMode: false }),
  };
};
